/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FabAppLauncherItem } from '@fabric/components/common';

/**
 * Contains the list of App Launcher items.  The URLs for each will be overwritten by the app.component with values
 * from the EnvironmentService
 */
export const appLauncherItemMap = {
  repo: {
    name: 'Source',
    imageUrl: 'assets/images/azure-repos@64px.png',
    linkUrl: '',
    description: 'Azure Repos',
  },
  backlog: {
    name: 'Backlog',
    imageUrl: 'assets/images/azure-boards@64px.png',
    linkUrl: '',
    description: 'Azure Boards',
  },
  discussion: {
    name: 'Discussion',
    imageUrl: 'assets/images/viva-engage@64px.png',
    linkUrl: '',
    description: 'Viva Engage',
  },
} satisfies Record<string, FabAppLauncherItem>;
